/* Scroll to buy — sends the visitor back up to the bundle cards.

   Finds the target automatically: the bundle picker first, then any add-to-cart
   form, then the product section. A CSS selector can be given on the button to
   override that. */

class ScrollToBuy extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;

    this.offset = Number(this.dataset.offset) || 0;
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      this.jump();
    });
  }

  findTarget() {
    var custom = this.dataset.target;
    if (custom) {
      var chosen = document.querySelector(custom);
      if (chosen) return chosen;
    }

    return (
      document.querySelector('.bundle-picker') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('.product-information') ||
      null
    );
  }

  jump() {
    var target = this.findTarget();
    if (!target) {
      console.warn('[scroll-to-buy] no target found on this page');
      return;
    }

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // scrollIntoView finds the right scrolling ancestor on its own, which
    // window.scrollTo does not when the layout uses a sticky column.
    target.style.scrollMarginTop = this.offset + 'px';
    target.scrollIntoView({
      behavior: reduced ? 'auto' : 'smooth',
      block: 'start',
      inline: 'nearest'
    });

    // Move keyboard focus too, so the jump is not purely visual.
    var focusable = target.querySelector('input, select, button, [tabindex]');
    if (focusable) {
      focusable.focus({ preventScroll: true });
    }
  }
}

if (!customElements.get('scroll-to-buy')) {
  customElements.define('scroll-to-buy', ScrollToBuy);
}
